import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../../_services/common.service';
import { HttpRequestService } from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { EncrDecrService } from './../../../_services/encr-decr.service';
import { Router } from '@angular/router';

import { ScriptService } from './../../../_services/script.service'
import { environment as env } from './../../../../environments/environment'
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  paymentForm: FormGroup;
  paymentFormSubmitStatus: boolean = false;
  select_card_id: any = '';
  saveCardList: Array<any> = [];
  userDetails: any;

  hyperPayLoaded: boolean = false;
  payment_url: any = env.base_url + '/order/success';
  paymentType : any = '';
  shippingBilling: any = null;
  constructor(public translate: TranslateService, private cService: CommonService,
    private httpService: HttpRequestService, private toastr: ToastrService,
    private formBuilder: FormBuilder, private EncrDecr: EncrDecrService,
    private router: Router,
    private encDecService: EncrDecrService,
    private scriptService: ScriptService) {


    this.cService.activelang.subscribe((lang) => {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
      console.log(this.payment_url);
    });
  }


  translateData: any = null;
  orderDetails: any = {};
  saveCardStatus: boolean = false;
  ngOnInit() {

    // this.paymentType = 'MADA';
    if (localStorage.getItem('_current_shipping')) {
      this.httpService.setModule('action').post('shipping_billing_address_details', {
        address_id: localStorage.getItem('_current_shipping')
      }).subscribe((response) => {

        console.log(response);
        if (response.status == 'success') {
          this.shippingBilling = response.data;
          // localStorage.setItem('_paymentType','MADA');
         //  this.paymentType = 'MADA';
          // this.handleChange(this.paymentType);
          if(localStorage.getItem('_payment_type')){
            this.paymentType = localStorage.getItem('_payment_type');
            this.paymentIni(localStorage.getItem('_payment_type'));
          }
        }
        else if (response.status == 'error') {
          this.router.navigate(['/order', 'billing']);
          this.toastr.error(response.message, 'Error:');
        }
      });
      //
    } else {
      this.toastr.error('Shipping address not found', 'Error:');
      this.router.navigate(['/order', 'billing']);
      //console.log('current shipping not found');
    }







    //this.loadScripts();
    this.userDetails = this.cService.getLoginUserDetails();
    this.translateData = this.translate.get([
      'CONGRATULATION',
      'SUCCESSFUL_ORDER_MSG',
      "NO",
      'YES'
    ]);
    this.paymentForm = this.formBuilder.group({
      'order_id': [''],
      'payment_for': ['P'],
      'amount': [''],
      'currency': ['SAR'],
      'customer_id': [this.userDetails.id],
      'card_type': ['', [Validators.required]],
      'card_holder': ['', [Validators.required, Validators.minLength(3), Validators.maxLength(255)]],
      'card_number': ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      'card_expiryMonth': ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      'card_expiryYear': ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      'card_cvv': ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      'save_card': ['']
    });
    // if (!sessionStorage.getItem('_corder') && !sessionStorage.getItem('_testOrTrainingOrderData') && !sessionStorage.getItem('_eventOrderData')) {
    //       this.router.navigate(['/order','cart']);
    //     } else {
    //       if(sessionStorage.getItem('_corder')){

    //         let orderDetails = JSON.parse(this.EncrDecr.get(sessionStorage.getItem('_corder')));
    //          console.log(orderDetails);
    //         this.httpService.setModule('action').post('place_your_order', {
    //           "id":(orderDetails.id)?orderDetails.id:null,
    //           "user_id": this.userDetails.id,
    //           "order_address_id":orderDetails.address,
    //           "price":orderDetails.price,
    //           "shipping_amount":orderDetails.shipping_amount,
    //           "coupon_amount":orderDetails.discount_price,
    //           "coupon_id":orderDetails.coupon_id
    //         }).subscribe((response) => {
    //           if (response.status == 'success') {
    //             this.userCardList();
    //             // this.httpService.setModule('action').post('user_card_list', {
    //             //   user_id:this.userDetails.id
    //             // }).subscribe((response) => {
    //             //   if (response.status == 'success') {
    //             //     this.saveCardList = response.data;
    //             //   }
    //             // })
    //             this.orderDetails = response.data;

    //             orderDetails['id'] = response.data['id'];
    //             sessionStorage.setItem('_corder', this.EncrDecr.set(JSON.stringify(orderDetails)));

    //             this.paymentForm.controls['order_id'].setValue(this.orderDetails.id);
    //             this.paymentForm.controls['amount'].setValue(this.orderDetails.price);

    //           }
    //           else if (response.status == 'error') {
    //             this.toastr.error(response.data, 'Error:');
    //           }
    //         })
    //       } else if(sessionStorage.getItem('_testOrTrainingOrderData')){
    //         this.userCardList();
    //         this.orderDetails= JSON.parse(this.EncrDecr.get(sessionStorage.getItem('_testOrTrainingOrderData')));
    //         this.paymentForm.controls['order_id'].setValue(this.orderDetails.id);
    //         this.paymentForm.controls['amount'].setValue(this.orderDetails.price);
    //         this.paymentForm.controls['payment_for'].setValue(this.orderDetails.order_for);
    //       } else if(sessionStorage.getItem('_eventOrderData')){
    //         this.userCardList();
    //         this.orderDetails= JSON.parse(this.EncrDecr.get(sessionStorage.getItem('_eventOrderData')));
    //         this.paymentForm.controls['order_id'].setValue(this.orderDetails.id);
    //         this.paymentForm.controls['amount'].setValue(this.orderDetails.price);
    //         this.paymentForm.controls['payment_for'].setValue('E');
    //       }

    //     }
  }
  loadScripts() {
    this.scriptService
      // one or more arguments
      .load(['hyperpay'], '757F46409090A480254EBE3E36A54515.uat01-vm-tx03')
      .then(data => {
        // script is loaded, use it
        console.log("dd",data)
        // alert(1)
        this.hyperPayLoaded = true;
      });
  }

  userCardList() {
    this.httpService.setModule('action').post('user_card_list', {
      user_id: this.userDetails.id
    }).subscribe((response) => {
      if (response.status == 'success') {
        this.saveCardList = response.data;
      }
    })
  }
  saveCard(e) {
    if (e.target.checked) {
      this.paymentForm.controls['save_card'].setValue(1);
    } else {
      this.paymentForm.controls['save_card'].setValue('');
    }
  }

  getSelectCardData(card = null) {
    if (card) {
      this.paymentForm.controls['card_type'].setValue(card.card_type);
      this.paymentForm.controls['card_holder'].setValue(card.holder_name);
      this.paymentForm.controls['card_number'].setValue(card.card_no);
      this.paymentForm.controls['card_expiryMonth'].setValue(card.exp_month);
      this.paymentForm.controls['card_expiryYear'].setValue(card.exp_year);
    } else {
      this.paymentForm.controls['card_type'].setValue('');
      this.paymentForm.controls['card_holder'].setValue('');
      this.paymentForm.controls['card_number'].setValue('');
      this.paymentForm.controls['card_expiryMonth'].setValue('');
      this.paymentForm.controls['card_expiryYear'].setValue('');
    }

  }
  payProcess() {
    this.paymentFormSubmitStatus = true;
    if (this.paymentForm.valid) {
      this.httpService.setModule('action').post('pay_process', this.paymentForm.value).subscribe((response) => {
        this.cService.setCartItmsCount(0);
        if (response.status == 'success') {
          this.translateData.subscribe((tData) => {
            Swal.fire({
              'title': tData['CONGRATULATION'],
              'text': tData['SUCCESSFUL_ORDER_MSG'],
              'type': 'success'
            }).then((result) => {
              localStorage.setItem('_payment_info', this.encDecService.set(JSON.stringify(response.data)));
              this.router.navigate(['/order', 'success']);
            })
          });
        } else {
          this.toastr.error(response.data, 'Error:');
        }
      })
    }
  }

  redirectUrl() {
    this.router.navigate(['/order', 'success']);
  }

  handleChange(val) {
    localStorage.setItem('_payment_type', val);
    location.reload();
    // this.paymentIni(val)
  }
  paymentIni(val) {
    //this.paymentType = '';
    // alert(val)
    let orderDetails = JSON.parse(this.EncrDecr.get(sessionStorage.getItem('_corder')));
    //let orderPaymentDetails = JSON.parse(this.EncrDecr.get(sessionStorage.getItem('_testOrTrainingOrderData')));

    console.log(orderDetails,'orderDetails');
    //console.log(orderDetails.order_for);
    this.httpService.setModule('action').post('pay_process', {
      "id": (orderDetails.id) ? orderDetails.id : null,
      "user_id": this.userDetails.id,
      "email": this.userDetails.email,
      "paymentMethod": val,
      "order_address_id": orderDetails.address,
      "country": this.shippingBilling.shipping_country.ccode,
      "amount": orderDetails.price.toFixed(2),
      "currency": 'SAR',
      "paymentType": 'DB',
      "street": this.shippingBilling.shipping_address,
      "city": this.shippingBilling.shipping_city.local[0].name,
      "state": this.shippingBilling.shipping_state,
      "postcode": this.shippingBilling.shipping_zipcode,
      "givenName": this.shippingBilling.shipping_name,
      "surname": this.shippingBilling.shipping_surname,
      "price": orderDetails.price.toFixed(2),
      "shipping_amount": orderDetails.shipping_amount.toFixed(2),
      "coupon_amount": orderDetails.discount_price.toFixed(2),
      "coupon_id": orderDetails.coupon_id,
      "payment_for": "purchase",

    }).subscribe((response) => {
      // console.log(this.EncrDecr.get(orderDetails.id));
     console.log(response.id,'kk');
      if (response.id != '') {

        const script = document.createElement("script");

        //script.src = `https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=${response.id}`;
        script.src = `https://oppwa.com/v1/paymentWidgets.js?checkoutId=${response.id}`;
        script.async = true;
        document.body.appendChild(script);
        localStorage.setItem('_payment_info', this.encDecService.set(JSON.stringify(response.data)));
        localStorage.setItem('_payment_for', 'P');

        //this.router.navigate(['/order','success']);
        // const form = document.getElementById("paymentForm");
        // console.log(form, 'formform')
        // //const form = document.createElement("form")
        // //form.action = this.router.navigate(['/order', 'payment']);

        // if (val === 'MADA') {
        //   form.setAttribute("data-brands", "MADA")
        // }
        // else {
        //   form.setAttribute("data-brands", "VISA MASTER AMEX")
        // }
        //form.setAttribute("class", "paymentWidgets");

        //document.body.appendChild(form);

        //document.body('.payment_form').appendChild(form);

        sessionStorage.setItem('order_id', response.order_id);

        //sessionStorage.setItem('_order_success_info',this.encDecService.set(JSON.stringify(response.data)));

        this.saveCardList = response.data;
        //this will store order items data

        var order_id = response.order_id;
        this.httpService.setModule('action').post('place_your_order', {
          "id": response.order_id,
          "user_id": this.userDetails.id
        }).subscribe((response) => {
          //console.log(response,'response');

          setTimeout(() => {
            //check stocks available or not
            this.httpService.setModule('action').post('check_stock_available', {
              "order_id": response.data.id,
            }).subscribe((response) => {

              if (response.status == 'success') {

                if (response.data.all_books_available == false) {
                  Swal.fire({
                    title: 'Oops...',
                    text: 'Stock not available for some of the books in your order.',
                  });

                  this.router.navigate(['/order', 'cart']);

                }
              }
              else if (response.status == 'error') {
                this.toastr.error(response.data, 'Error:');
              }
            })
          }, 500)





        })



      }
    })
    // this.orderDetails = response.data;

  }





}
